import { LineData, LineSeriesOptions } from "../chart.typings";
import LineSeries from "./lineSeries";
import { LineType } from "lightweight-charts";

class StepLineSeries extends LineSeries {

    getDefaultOptions(): LineSeriesOptions {
        const options = super.getDefaultOptions();
        options.lineType = LineType.WithSteps;
        return options;
    }
}

export default StepLineSeries;
